export { default } from './BlocLinks';
